import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  clearDataLogbookAdministrativeProcedures,
  getDataLogbookAdministrativeProcedures,
  updateDataLogbookAdministrativeProcedures,
} from "../../../redux/logbookAdministrativeProceduresReduser/actionLogbookAdministrativeProcedures";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import EditableTableForKnoweledgeTest from "../../../components/knowledgeTestComponents/commonComponents/EditableTableForKnoweledgeTest/EditableTableForKnoweledgeTest";

import { columnsForLogbookAdministrativeProceduresForPrint } from "./columnsLogbookAdministrativeProcedures";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";
import {
  options,
  setOptionsSections,
  setOptionsNsiAp,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./logbookAdministrativeProcedures.module.css";

const LogbookAdministrativeProcedures = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    apcode: null,
    leName: "",
    leUnp: "",
    section: null,
    dateStart: "",
    dateEnd: "",
  });

  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.logbookAdministrativeProceduresReducer);
  const { sortedMenuNames } = useSelector((state) => state.roleControllerReducer);
  const dictionaryReducer = useSelector((state) => state.dictionaryReducer);

  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.LOGBOOK_ADMINISTRATIVE_PROCEDURES?.magazinePrinting
      ?.chapterActionId,
  );

  const handleShowModal = () => {
    setIsShowModal(!isShowModal);
  };

  const handleClickCheckBox = (data) => {
    dispatch(updateDataLogbookAdministrativeProcedures(data));
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleSearch = () => {
    dispatch(getDataLogbookAdministrativeProcedures(searchParams));
  };

  const handleClear = () => {
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        apcode: null,
        leName: "",
        leUnp: "",
        section: null,
        dateStart: "",
        dateEnd: "",
      }),
    );
    dispatch(clearDataLogbookAdministrativeProcedures());
  };

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections,
        options.inputsLogbookAdministrativeProcedures.key,
      );
    }
    if (dictionaryReducer.allNsiAp?.length > 0) {
      setOptionsNsiAp(
        dictionaryReducer.allNsiAp,
        options.inputsLogbookAdministrativeProcedures.key,
      );
    }
  }, [dictionaryReducer]);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsLogbookAdministrativeProcedures}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        addBtnDis={true}
        setShow={handleShowModal}
        data={data}
        searchParams={searchParams}
        printAccess={printAccess}
      />
      <EditableTableForKnoweledgeTest
        mode={"add"}
        columns={columnsForLogbookAdministrativeProceduresForPrint}
        tableData={data}
        caption={"Результат поиска"}
        handleTableDataUpdate={handleClickCheckBox}
        isSmall={true}
      />
    </div>
  );
};

export default LogbookAdministrativeProcedures;
